import {createMachine, actions, send, assign} from "xstate";

const createFolderFormMachine = () => {

    const validate = (value) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (!value) {
                    return reject(new Error('You must provide a folder name.'));
                }

                resolve(value);
            }, 250);
        });
    };

    return createMachine({
        id: 'create-folder-form-machine',
        initial: 'editing',
        context: {
            validationErrorMessage: null
        },
        states: {
            editing: {
                on: {
                    SUBMIT: 'validating'
                },
                initial: 'idle',
                states: {
                    idle: {},
                    invalid: {}
                }
            },
            validating: {
                invoke: {
                    id: 'validating',
                    src: (_, {name}) => validate(name),
                    onDone: {
                        target: 'submitting',
                        actions: assign({
                            validationErrorMessage: null
                        })
                    },
                    onError: {
                        target: 'editing.invalid',
                        actions: assign({
                            validationErrorMessage: (ctx, event) => event.data.message
                        })
                    }
                }
            },
            submitting: {
                invoke: {
                    id: 'submit',
                    src: 'execCreateFolderRequest',
                    onDone: {
                        target: 'submitted'
                    },
                    onError: {
                        target: 'editing',
                        actions: assign({
                            validationErrorMessage: (ctx, event) => {
                                return "Sorry, your folder could not be created at this time.";
                            }
                        })
                    }
                }
            },
            submitted: {
                final: true,
                invoke: {
                    id: 'submit',
                    src: 'onDone',
                }
            }
        }
    });
};

export {createFolderFormMachine};
